<skl-dialog-content-ins>
    <skl-dialog-header-ins
        id="create-inventory-document-to-commercial-document-failed-dialog-header"
        [title]="'scenes.shared.dialog.create-inventory-document-to-commercial-document.'+ l10nDocumentPrefix + '.messages.header' | translate"
        (onClose)="onCancel()">
    </skl-dialog-header-ins>
    <ins-content>
        <div class="main">
            <div class="description-box text-description" id="create-inventory-document-to-commercial-document-failed-dialog-description">
                <div>{{description}}</div>
                <div>{{'scenes.shared.dialog.create-inventory-document-to-commercial-document.messages.possible-actions' | translate}}</div>
            </div>
            <div class="options-wrapper" id="create-inventory-document-to-commercial-document-failed-dialog-options">
                @for (option of options; track option) {
                    <div class="select-option" (click)="selectOption(option.value)">
                        @if (isSelected(option.value)) {
                            <div class="check-icon">
                                <ins-icon name="check" size="26px" shape="circle" inner-color="white" color="primary"></ins-icon>
                            </div>
                        }
                        <div class="check-icon">
                            @if (!isSelected(option.value)) {
                                <div class="unselected-box"></div>
                            }
                        </div>
                        <div class="description">
                            <div class="align--tiny-bottom">{{option.label}}</div>
                            <div class="text-description text-small">{{option.description}}</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </ins-content>

    <ins-footer class="dialog__buttons">
        <skl-button
            id="create-inventory-document-to-commercial-document-failed-dialog-confirm-button"
            typeName="accent"
            (click)="onConfirm()">
            {{'scenes.shared.dialog.create-inventory-document-to-commercial-document.buttons.confirm' | translate}}
        </skl-button>
    </ins-footer>
</skl-dialog-content-ins>
